import { IGlobalMessage } from "../../rz-status_models";
import { useTimer } from "../contextProviders/TimerContext";

export default function({messages}: {messages: IGlobalMessage[] | null}) {
    const tick = useTimer();

    if(messages != null && messages.length > 0) {
        return <section>
        <section id="notifications">
            {messages.map((n, i) => <section key={i} className="banner incidentinfo notification clearfix">
                    <article>
                        <header>
                            <p>{n.text}</p>
                        </header>
                    </article>
                </section> 
                )}
            </section>
        </section>
    }
    return <></>
}